// http.js
import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL || '/api',
  timeout: 15000,
})

// 请求拦截器
instance.interceptors.request.use(cfg => {
  const token = localStorage.getItem('token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

// 响应拦截器
instance.interceptors.response.use(
  res => res,
  err => {
    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      // 删除token并跳转
      localStorage.removeItem('token')
      localStorage.removeItem('lastActiveTime')
      if (window.location.pathname !== '/login') {
        window.location.href = '/login'
      }
    }
    return Promise.reject(err)
  }
)

export default instance
